module.exports = __webpack_public_path__ + "img/depmap_svg_V15.cb1865aa.svg";